import { DateFilterTypeEnum } from '../enums/dateFilterType.enum';
import { FilterRequest } from './filterRequest.model';

export class ExposureRequest extends FilterRequest {
  previousStartDate: number;
  previousEndDate: number;
}

export class ExposureDetailRequest {
  orgLevelId: string;
  segId: string;
  taskId: string;
  startDate: number;
  taskGroupId?: string;
  endDate: number;
  analyteId: string;
  dateFilterType: DateFilterTypeEnum;
  previousStartDate: number;
  previousEndDate: number;
  sampleTypes?: number[];
}

export class TaskContributionRequest {
  id: string;
  labResults: LabResult[];
}

export class LabResult {
  parameterId: string;
  value: number;
  twa: number;
  nonDetect: boolean;
}
